import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import { Typography, Grid, Container, Button, Hidden, IconButton, TextField, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import ExtraItemsProducts from '../../components/CalendarControls/ExtraItemsProducts';
import { genfunction } from '../../helpers';
import { useDispatch, useSelector } from 'react-redux';
import {
    actionShopCartAddEventWithTourHold, actionShopCartSetManageMyBooking,
    actionShopCartResetStateWithTourHold, actionShopCartResetStateWithUniqueCouponHold, actionRemoveCoupon,
    actionShopCartSetMmbAmountToPay, actionShopCartSetRefundType
} from 'actions';
import { actionResetBooking } from 'actions';
import { actionResetExtraItems } from 'actions';
import ErrorHandling from '../../components/ErrorHandling/ErrorHandling';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { actionGetCoupon, actionResetCoupon, actionEndCouponLoading } from 'actions';
import { actionResetUniqueCouponCardHoldState } from 'actions';
import { actionResetCouponAlreadyApplied, actionShopCartRemoveCoupons, actionShopCartResetError, actionShopCartResetMembership, actionShopCartResetIDME } from 'actions';
import { actionDeleteUniqueCoupon } from 'actions';
import { actionStartAppLoader, actionEndAppLoader } from '../../actions/actionAppLoader';

const { DefaultCostRateID, ChangeDateTimeHeading, RefundCreditCardButton, RefundGiftCardButton } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        height: '40px'
    },
    diplaynone: {
        display: "none"
    },
    hideBtn: {
        display: 'none'
    }
}));

const ConfimBookingChanges = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const bookingreducer = useSelector(state => state.reducerBooking);
    const newExtraItem = useSelector(state => state.reducerExtraItems.extraItem);
    const cartEvents = useSelector(state => state.reducerShopCart.events);
    const shopcartreducer = useSelector(state => state.reducerShopCart);
    const reducerCoupon = useSelector(state => state.reducerCoupon);
    const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);
    let bookingID = bookingreducer && bookingreducer.booking[0] ? bookingreducer.booking[0].BookingTypeID : 0;
    const bkngType = bookingTypes && bookingTypes.length > 0 ? bookingTypes.filter(x => x.BookingTypeID == bookingID)[0] : null;
    const uniqueCouponHolds = useSelector(state => state.reducerUniqueCouponHolds);

    let amountaftercoupon = genfunction.subproducttotal(cartEvents, null, null, null, null, null, null, [], []);

    //States Initializing Start

    const [couponNo, setcouponNo] = useState("");
    const [errormsg, seterrormsg] = useState("");
    const [open, setOpen] = React.useState(false);
    const [isredirectclicked, setisredirectclicked] = useState(false);

    //States Initializing End


    //Set States Start

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (reducerCoupon.loading)
            actionStartAppLoader(dispatch)
        else
            actionEndAppLoader(dispatch);
    }, [reducerCoupon.loading]);

    useEffect(() => {
        if (reducerCoupon.couponError !== undefined && reducerCoupon.couponError.length > 0) {
            seterrormsg(reducerCoupon.couponError);

            if (cartEvents && cartEvents.length > 0) {
                actionShopCartResetStateWithTourHold(dispatch, cartEvents);
                actionShopCartResetStateWithUniqueCouponHold(dispatch);
            }
        }
    }, [reducerCoupon.couponError]);

    //Set States End

    useEffect(() => {
        if (cartEvents && cartEvents.length > 0 && shopcartreducer.tourCoupons && shopcartreducer.tourCoupons.length < 1) {
            actionShopCartResetStateWithTourHold(dispatch, cartEvents);
            actionShopCartResetStateWithUniqueCouponHold(dispatch);
        }
    }, [shopcartreducer.tourCoupons])


    const CouponsTotal = () => {
        let total = 0;

        if (cartEvents && cartEvents.length > 0) {
            cartEvents.map(x => {
                x.CouponItems.map(e => {
                    total += e.TotalAmount;
                });
            })
        }

        return total;
    }

    const AmountToPay = () => {

        let previouspaid = totalpaid();

        if (cartEvents && cartEvents.length > 0) {
            return amountaftercoupon - previouspaid;
        }

        if (newExtraItem && newExtraItem.TotalAmount) {
            return newExtraItem.TotalAmount - previouspaid;
        }
        return 0;
    }


    const constredirecttofindmybpooking = () => {

        actionResetBooking(dispatch);
        actionResetExtraItems(dispatch);
        actionShopCartSetManageMyBooking(dispatch, false, false);
        actionResetCoupon(dispatch);
        actionShopCartRemoveCoupons(dispatch);
        actionShopCartResetMembership(dispatch);
        actionShopCartResetIDME(dispatch);

        if ((cartEvents && cartEvents.length > 0) || (shopcartreducer.tourCoupons && shopcartreducer.tourCoupons.length > 0)) {
            actionShopCartResetStateWithTourHold(dispatch, cartEvents);
            actionShopCartResetStateWithUniqueCouponHold(dispatch);
        }

        props.history.push({
            pathname: '/findmybooking'
        })
    }


    useEffect(() => {

        if (isredirectclicked && shopcartreducer.error.length < 1 && shopcartreducer.events && shopcartreducer.events.length > 0 && AmountToPay() > -1) {
            actionShopCartSetMmbAmountToPay(dispatch, AmountToPay());
            setisredirectclicked(false);

            props.history.push({
                pathname: '/managecheckout',
                refundType: ''
            })
        }
        if (isredirectclicked && shopcartreducer.error.length > 0) {
            seterrormsg(shopcartreducer.error);
            setisredirectclicked(false);
        }
    }, [shopcartreducer, (isredirectclicked === true)]);

    const addeventstotourholdaction = () => {
        let filterdata = { ...newExtraItem };
        filterdata.TourProducts = filterdata.TourProducts.filter(product => product.Quantity > 0);
        let cartdata = [...cartEvents];

        if (filterdata && filterdata.hasOwnProperty('BookingTypeID')) {
            let usealternamteMerchant = false;
            if (bkngType && bkngType.hasOwnProperty('UseAlternateMerchantOnline')) {
                usealternamteMerchant = bkngType.UseAlternateMerchantOnline;
            }

            filterdata.UseAlternateMerchantOnline = usealternamteMerchant;
        }

        actionShopCartAddEventWithTourHold(dispatch, filterdata, cartdata);
    }

    const constredirecttomanagecheckout = () => {

        if (ValidateQuanity()) {
            if (AmountToPay() >= 0 && newExtraItem && newExtraItem.hasOwnProperty('TotalAmount')) {

                if (shopcartreducer.tourCoupons && shopcartreducer.tourCoupons.length < 1) {
                    addeventstotourholdaction();
                }

                setisredirectclicked(true);
            }
            else {
                handleClickOpen();
            }
        }
    }

    const ValidateQuanity = () => {
        let MinTicket = bkngType.MinimumTickets
        let MaxTicket = bkngType.MaximumTickets;

        let CartQty = 0;
        let NewQty = 0;
        let TotalTicketCount = 0;
        if (cartEvents && cartEvents.length > 0) {

            let cartTourEvent = cartEvents.find(x => x.TourEventID == newExtraItem.TourEventID);
            if (cartTourEvent && cartTourEvent.TourProducts.length > 0) {
                CartQty = cartTourEvent.TourProducts.filter(p => p.AffectsCapacity).reduce((a, b) => {
                    let aqty = a.Quantity === undefined ? 0 : a.Quantity;
                    let bqty = b.Quantity === undefined ? 0 : b.Quantity;
                    let newobj = { Quantity: aqty + bqty }
                    return newobj;
                }).Quantity;
            }
        }

        NewQty = newExtraItem.TourProducts.filter(p => p.AffectsCapacity).reduce((a, b) => {
            let aqty = a.Quantity === undefined ? 0 : a.Quantity;
            let bqty = b.Quantity === undefined ? 0 : b.Quantity;
            let newobj = { Quantity: aqty + bqty }
            return newobj;
        }).Quantity;

        TotalTicketCount = CartQty + NewQty;

        if (newExtraItem.SeatsAvailable == 0 || newExtraItem.BookNowOption != "Book Now") {
            seterrormsg("Tickets not longer available, please choose another time");
            return false;
        }
        else if (NewQty > newExtraItem.SeatsAvailable) {
            seterrormsg("Maximum of " + newExtraItem.SeatsAvailable + " tickets available");
            return false;
        }
        else if (TotalTicketCount < MinTicket) {
            seterrormsg("Minimum tickets per order is " + MinTicket)
            return false;
        }
        else if (TotalTicketCount > MaxTicket) {
            seterrormsg("Maximum of " + MaxTicket + " tickets allowed")
            return false;
        }
        else {
            return true;
        }
    }
    const applyrefund = (type) => {

        if (shopcartreducer.tourCoupons && shopcartreducer.tourCoupons.length < 1) {
            addeventstotourholdaction();
        }

        actionShopCartSetMmbAmountToPay(dispatch, AmountToPay());
        actionShopCartSetRefundType(dispatch, type);

        props.history.push({
            pathname: '/managecheckout',
            refundType: type
        })
    }

    const totalpaid = () => {
        let total = 0;
        if (bookingreducer.booking && bookingreducer.booking[0] && bookingreducer.booking[0].BookingPayments && bookingreducer.booking[0].BookingPayments.length > 0) {
            total = bookingreducer.booking[0].BookingPayments.map(({ PaymentAmount }) => PaymentAmount).reduce((sum, i) => sum + i, 0);
        }

        return total;
    }


    const CheckCouponNo = (couponCode) => {
        if (couponCode == '') {
            seterrormsg('Please enter Coupon number.')
        }
        else {
            if (couponCode.length > 0) {

                if (!CheckUniqueCouponAlreadyApplied(couponCode)) {
                    if (newExtraItem && newExtraItem.TotalAmount) {
                        addeventstotourholdaction();
                        setcouponNo(couponCode);
                    }
                }
                else {
                    seterrormsg("Unique Coupon already applied, please remove existing coupon and try again.");
                    setcouponNo('');
                }
            }
        }
    }

    useEffect(() => {

        if (cartEvents && cartEvents.length > 0 && couponNo.length > 0) {
            actionGetCoupon(dispatch, couponNo);
            setcouponNo('');
        }
    }, [cartEvents]);

    const errorcancelhandle = () => {

        // Reset Coupons
        actionResetUniqueCouponCardHoldState(dispatch);
        actionResetCouponAlreadyApplied(dispatch);
        actionResetCoupon(dispatch);
        actionShopCartResetError(dispatch);
        setcouponNo('');
        seterrormsg('');
        setisredirectclicked(false);
    }

    const CheckUniqueCouponAlreadyApplied = (couponCode) => {

        let exist = false;
        if (cartEvents && cartEvents.length > 0) {

            cartEvents.map(e => {

                if (e.CouponItems.filter(x => x.UniqueCouponCode == couponCode && x.isUniqueCoupon).length > 0) {
                    exist = true;
                }
            });
        }

        return exist;
    }

    useEffect(() => {
        if (uniqueCouponHolds.UniqueCouponError && uniqueCouponHolds.UniqueCouponError.length > 0) {
            seterrormsg(uniqueCouponHolds.UniqueCouponError);
            actionEndCouponLoading(dispatch);
        }
    }, [uniqueCouponHolds.UniqueCouponError]);

    const openerrorpopup = () => {
        return (errormsg != "")
    }

    function ShowCurrentBookingStartAndEndTime() {
        let time = "";

        if (bookingreducer.booking && bookingreducer.booking[0]) {

            time += genfunction.GetEventDateReceiptFormat(bookingreducer.booking[0].EventStartDateTime);
            time += ' - ' + genfunction.AppendEndTime(bookingreducer.booking[0].EventEndDateTime);
        }

        return time;
    }

    function ShowStartAndEndTime(bkngType, newExtraItem) {
        let time = "";

        if (bkngType && newExtraItem) {

            if (bkngType.ShowStartTime) {
                time += genfunction.GetEventDateReceiptFormat(newExtraItem.EventStartDateTime);
            }

            if (bkngType.ShowEndTime && !bkngType.ShowStartTime) {
                time += genfunction.GetEventDateReceiptFormat(newExtraItem.EventStartDateTime);
            }

            if (bkngType.ShowEndTime && bkngType.ShowStartTime) {
                time += ' - ' + genfunction.AppendEndTime(newExtraItem.EventEndDateTime);
            }

            if (!bkngType.ShowStartTime && !bkngType.ShowEndTime) {
                time += genfunction.GetEventDateReceiptFormatwithoutTime(newExtraItem.EventStartDateTime);
            }
        }

        return time;
    }

    const removeclickhandler = (eventid, productid, couponID, couponRefHold) => {
        if (couponRefHold !== null) {
            if (DeleteCouponsHolds(couponID)) {
                actionDeleteUniqueCoupon(dispatch, couponRefHold);
            }
        }

        actionRemoveCoupon(dispatch, eventid, productid);
    }

    const DeleteCouponsHolds = (CouponID) => {
        let removeUniqueCouponHolds = false;
        if (cartEvents) {

            cartEvents.map(x => {
                if (x.CouponItems.filter(x => x.CouponID == CouponID && x.isUniqueCoupon).length < 2) {
                    removeUniqueCouponHolds = true;
                }
            })
        }

        return removeUniqueCouponHolds;
    }

    const redirecttofindmybpooking = () => {

        props.history.push({
            pathname: '/findmybooking'
        })
    }

    return (

        //Desktop and Laptop (smDown)
        //Tablet (xsDown mdUp)
        //Mobile (smUp)

        <Container className={classes.root}>
            <ErrorHandling msg={errormsg} open={openerrorpopup()} handleclose={errorcancelhandle} />
            <Grid container justify="center" spacing={1} className={bookingreducer.booking[0] && bookingreducer.booking[0].BookingID ? '' : classes.hideBtn}>
                <Grid item xs={12} md={7}>
                    <Hidden smDown>
                        <Typography align="center" variant="h1" style={{ padding: "15px", fontWeight: "bold", marginTop: 0 }}>
                            {ChangeDateTimeHeading}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography align="center" variant="h2" style={{ padding: "15px", fontWeight: "bold", marginTop: 15 }}>
                            {ChangeDateTimeHeading}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography align="center" variant="h3" style={{ padding: "15px", fontWeight: "bold", marginTop: 20 }}>
                            {ChangeDateTimeHeading}
                        </Typography>
                    </Hidden>

                </Grid>
                <Grid item xs={12} md={7}>

                    <Hidden smDown>
                        <Typography className={classes.tourheaderbox} align="center" variant="h4" style={{ padding: 10 }}>
                            Original Booking : {ShowCurrentBookingStartAndEndTime()}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h5" style={{ padding: 12 }}>
                            Original Booking : {ShowCurrentBookingStartAndEndTime()}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h6" style={{ padding: 10, height: 'auto' }}>
                            Original Booking : {ShowCurrentBookingStartAndEndTime()}
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography align="center" variant="h6" style={{ padding: "10px" }}>
                            For reference, here are the original tickets in your order.
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography align="center" variant="subtitle1" style={{ padding: "10px" }}>
                            For reference, here are the original tickets in your order.
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography align="center" variant="subtitle2" style={{ padding: "10px" }}>
                            For reference, here are the original tickets in your order.
                        </Typography>
                    </Hidden>


                    <Hidden smDown>
                        <Typography align="center" variant="h6" style={{ padding: "5px" }}>
                            These will all be replaced with tickets selected below.
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography align="center" variant="subtitle1" style={{ padding: "5px" }}>
                            These will all be replaced with tickets selected below.
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography align="center" variant="subtitle2" style={{ padding: "5px" }}>
                            These will all be replaced with tickets selected below.
                        </Typography>
                    </Hidden>



                    {bookingreducer.booking[0] && bookingreducer.booking[0].hasOwnProperty('BookingProducts') && bookingreducer.booking[0].BookingProducts.length > 0 ?

                        bookingreducer.booking[0].BookingProducts.map((prod, i) => {
                            return prod.Quantity > 0 ?
                                <Grid style={{ padding: "10px" }} container item xs={12} ms={12} lg={12} key={prod.TourProductID}>
                                    <Grid item xs={6} ms={6} lg={6}>

                                        <Hidden smDown>
                                            <Typography align="right" variant="h4" style={{ padding: "10px" }}>
                                                {prod.Quantity} x {prod.TourProductName}
                                            </Typography>
                                        </Hidden>

                                        <Hidden xsDown mdUp>
                                            <Typography align="right" variant="h5" style={{ padding: "10px" }}>

                                                {prod.Quantity} x {prod.TourProductName}
                                            </Typography>
                                        </Hidden>

                                        <Hidden smUp>
                                            <Typography align="right" variant="h6" style={{ padding: "10px" }}>

                                                {prod.Quantity} x {prod.TourProductName}
                                            </Typography>
                                        </Hidden>

                                    </Grid>

                                    <Grid item xs={6} ms={6} lg={6}>

                                        <Hidden smDown>
                                            <Typography align="left" variant="h4" style={{ padding: "10px" }}>

                                                {genfunction.ccyFormat(prod.ProductLinePriceInclTax)}
                                            </Typography>
                                        </Hidden>

                                        <Hidden xsDown mdUp>
                                            <Typography align="left" variant="h5" style={{ padding: "10px" }}>

                                                {genfunction.ccyFormat(prod.ProductLinePriceInclTax)}
                                            </Typography>
                                        </Hidden>

                                        <Hidden smUp>
                                            <Typography align="left" variant="h6" style={{ padding: "10px" }}>

                                                {genfunction.ccyFormat(prod.ProductLinePriceInclTax)}
                                            </Typography>
                                        </Hidden>

                                    </Grid>
                                </Grid> : null
                        }) : null}
                </Grid>

                <Grid item xs={12} md={7} style={{ padding: "15px" }}>
                    <Hidden smDown>
                        <Typography className={classes.tourheaderbox} align="center" variant="h4" style={{ padding: 10 }}>
                            New Booking :  {ShowStartAndEndTime(bkngType, newExtraItem)}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h5" style={{ padding: 12 }}>
                            New Booking :  {ShowStartAndEndTime(bkngType, newExtraItem)}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h6" style={{ padding: 10, height: 'auto' }}>
                            New Booking :  {ShowStartAndEndTime(bkngType, newExtraItem)}
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography align="center" variant="h6" style={{ padding: "10px" }}>
                            Select the tickets and add ons for your new date / time.
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography align="center" variant="subtitle1" style={{ padding: "10px" }}>
                            Select the tickets and add ons for your new date / time.
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography align="center" variant="subtitle2" style={{ padding: "10px" }}>
                            Select the tickets and add ons for your new date / time.
                        </Typography>
                    </Hidden>


                    <Hidden smDown>
                        <Typography align="center" variant="h6" style={{ padding: "5px" }}>
                            These tickets will replace the tickets from your original order.
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography align="center" variant="subtitle1" style={{ padding: "5px" }}>
                            These tickets will replace the tickets from your original order.
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography align="center" variant="subtitle2" style={{ padding: "5px" }}>
                            These tickets will replace the tickets from your original order.
                        </Typography>
                    </Hidden>

                    <Grid item xs={12} md={12} style={{ margin: "auto" }}>
                        <ExtraItemsProducts
                            allowQuantityChange={shopcartreducer.tourCoupons && shopcartreducer.tourCoupons.length > 0 ? false : true}
                            hidetopheading={true} isMMB={true}
                            tourEventId={props.location.eventID} ismembershipapplied={props.location.ismembershipapplied ? props.location.ismembershipapplied : false}
                            membercostrate={props.location.membercostrate ? props.location.membercostrate : DefaultCostRateID}
                            bookingtypeID={props.location.bookingtypeID !== undefined && props.location.bookingtypeID > 0 ? props.location.bookingtypeID : bookingID} />
                    </Grid>

                    <Grid item xs={12} md={12} >

                        <Grid item xs={12} md={12} align="center" style={{ marginTop: "15px" }}>
                            <TextField
                                margin="dense"
                                id="couponcode"
                                name="couponcode"
                                label="Enter Coupon Code"
                                type="text"
                                value={couponNo}
                                onChange={event => {
                                    setcouponNo(event.target.value);
                                }}
                            />

                            <Hidden smDown>
                                <Button variant="contained" size="medium" color="primary"
                                    style={{ padding: "12px", marginLeft: "10px" }}
                                    onClick={() => { CheckCouponNo(couponNo) }}
                                    disabled={props.amounttopay <= 0 || shopcartreducer.tourCoupons && shopcartreducer.tourCoupons.length > 0}
                                >
                                    Apply
                                </Button>
                            </Hidden>

                            <Hidden xsDown mdUp>
                                <Button variant="contained" size="small" color="primary"
                                    style={{ padding: 12, marginLeft: 10, marginTop: 5 }}
                                    onClick={() => { CheckCouponNo(couponNo) }}
                                    disabled={props.amounttopay <= 0 || shopcartreducer.tourCoupons && shopcartreducer.tourCoupons.length > 0}
                                >
                                    Apply
                                </Button>
                            </Hidden>

                            <Hidden smUp>
                                <Button variant="contained" size="small" color="primary"
                                    style={{ padding: 12, marginLeft: 10, marginTop: 5 }}
                                    onClick={() => { CheckCouponNo(couponNo) }}
                                    disabled={props.amounttopay <= 0 || shopcartreducer.tourCoupons && shopcartreducer.tourCoupons.length > 0}
                                >
                                    Apply
                                </Button>
                            </Hidden>

                        </Grid>
                    </Grid>


                </Grid>

                <Grid item xs={12} md={7} style={{ padding: "15px" }}>
                    <Hidden smDown>
                        <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ padding: "5px" }}>
                            Booking Summary
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h3" style={{ padding: "5px" }}>
                            Booking Summary
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h4" style={{ padding: "7px" }}>
                            Booking Summary
                        </Typography>
                    </Hidden>


                    <Hidden smDown>
                        <Typography variant="h4" style={{ padding: "10px" }}>
                            Original Cost : {bookingreducer.booking[0] && bookingreducer.booking[0].BookingPayments ? genfunction.ccyFormat(bookingreducer.booking[0].BookingPayments[0].PaymentAmount) : genfunction.ccyFormat(0)}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h5" style={{ padding: "10px" }}>
                            Original Cost : {bookingreducer.booking[0] && bookingreducer.booking[0].BookingPayments ? genfunction.ccyFormat(bookingreducer.booking[0].BookingPayments[0].PaymentAmount) : genfunction.ccyFormat(0)}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" style={{ padding: "10px" }}>
                            Original Cost : {bookingreducer.booking[0] && bookingreducer.booking[0].BookingPayments ? genfunction.ccyFormat(bookingreducer.booking[0].BookingPayments[0].PaymentAmount) : genfunction.ccyFormat(0)}
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography variant="h4" style={{ padding: "10px" }}>
                            New Cost : {genfunction.ccyFormat(newExtraItem.TotalAmount ? newExtraItem.TotalAmount : 0)}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h5" style={{ padding: "10px" }}>
                            New Cost : {genfunction.ccyFormat(newExtraItem.TotalAmount ? newExtraItem.TotalAmount : 0)}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" style={{ padding: "10px" }}>
                            New Cost : {genfunction.ccyFormat(newExtraItem.TotalAmount ? newExtraItem.TotalAmount : 0)}
                        </Typography>
                    </Hidden>


                </Grid>

                <Grid item xs={12} md={7} style={{ padding: "15px" }}>
                    <Hidden smDown>
                        <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ padding: "5px" }}>
                            Amount to Pay
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h3" style={{ padding: "5px" }}>
                            Amount to Pay
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h4" style={{ padding: "7px" }}>
                            Amount to Pay
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography variant="h4" style={{ padding: "10px" }}>
                            New Cost :{genfunction.ccyFormat(newExtraItem.TotalAmount ? newExtraItem.TotalAmount : 0)}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h5" style={{ padding: "10px" }}>
                            New Cost :{genfunction.ccyFormat(newExtraItem.TotalAmount ? newExtraItem.TotalAmount : 0)}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" style={{ padding: "10px" }}>
                            New Cost :{genfunction.ccyFormat(newExtraItem.TotalAmount ? newExtraItem.TotalAmount : 0)}
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography variant="h4" style={{ padding: "10px" }}>
                            Coupon Applied : {genfunction.ccyFormat(CouponsTotal())}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h5" style={{ padding: "10px" }}>
                            Coupon Applied : {genfunction.ccyFormat(CouponsTotal())}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" style={{ padding: "10px" }}>
                            Coupon Applied : {genfunction.ccyFormat(CouponsTotal())}
                        </Typography>
                    </Hidden>


                    <Grid item xs={12} md={12} className={cartEvents !== undefined && cartEvents.length > 0 ? "" : classes.diplaynone}>
                        <Table size="small" style={{ padding: "15px" }} aria-label="spanning table">
                            <TableBody>
                                {cartEvents !== undefined && cartEvents.length > 0 ?
                                    cartEvents.map(event =>
                                        event.CouponItems.map(e =>
                                            <TableRow >
                                                <TableCell className={classes.tablecell} align="left">
                                                    <IconButton
                                                        edge="end"
                                                        size="small"
                                                        onClick={() => removeclickhandler(e.TourEventID, e.TourProductID, e.CouponID, e.CouponHoldRef)}>
                                                        <CancelIcon color={"error"} />
                                                    </IconButton>{'      ' + e.ApplyDiscountTourProductName + '      (' + e.UniqueCouponCode + ')'}
                                                </TableCell>
                                                <TableCell align="right" className={classes.couponAmount}>-{genfunction.ccyFormat(e.TotalAmount)}</TableCell>
                                            </TableRow>
                                        )) : null
                                }
                            </TableBody>
                        </Table>
                    </Grid>

                    <Hidden smDown>
                        <Typography variant="h4" style={{ padding: "10px" }}>
                            Previous Payment : {bookingreducer.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h5" style={{ padding: "10px" }}>
                            Previous Payment : {bookingreducer.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" style={{ padding: "10px" }}>
                            Previous Payment : {bookingreducer.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0}
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography variant="h4" style={{ padding: "10px", fontWeight: "bold" }}>
                            Amount to Pay : {genfunction.ccyFormat(AmountToPay())}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h5" style={{ padding: "10px", fontWeight: "bold" }}>
                            Amount to Pay : {genfunction.ccyFormat(AmountToPay())}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" style={{ padding: "10px", fontWeight: "bold" }}>
                            Amount to Pay : {genfunction.ccyFormat(AmountToPay())}
                        </Typography>
                    </Hidden>
                </Grid>


                <Grid item xs={12} md={7} align="center" style={{ marginTop: "15px" }}>
                    <Hidden smDown>
                        <Button variant="outlined" size="medium" color="primary"
                            style={{ padding: "12px", marginTop: 0 }}
                            onClick={() => constredirecttofindmybpooking()}>
                            Cancel Changes
                        </Button>

                        <Button variant="contained" size="medium" color="primary"
                            style={{ padding: "12px", marginLeft: "10px", marginTop: 0 }}
                            onClick={() => {
                                setisredirectclicked(true);
                                constredirecttomanagecheckout();
                            }}
                        >
                            Confirm Changes
                        </Button>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Button variant="outlined" size="small" color="primary"
                            style={{ padding: "12px", marginTop: 10 }}
                            onClick={() => constredirecttofindmybpooking()}>
                            Cancel Changes
                        </Button>

                        <Button variant="contained" size="small" color="primary"
                            style={{ padding: "12px", marginLeft: "10px", marginTop: 10 }}
                            onClick={() => {
                                setisredirectclicked(true);
                                constredirecttomanagecheckout();
                            }}
                        >
                            Confirm Changes
                        </Button>
                    </Hidden>

                    <Hidden smUp>
                        <Button variant="outlined" size="small" color="primary"
                            style={{ padding: "12px", marginTop: 10 }}
                            onClick={() => constredirecttofindmybpooking()}>
                            Cancel Changes
                        </Button>

                        <Button variant="contained" size="small" color="primary"
                            style={{ padding: "12px", marginLeft: "10px", marginTop: 10 }}
                            onClick={() => {
                                setisredirectclicked(true);
                                constredirecttomanagecheckout();
                            }}
                        >
                            Confirm Changes
                        </Button>
                    </Hidden>

                </Grid>
            </Grid>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                disableEscapeKeyDown={true}
                disableBackdropClick={true}
            >
                <DialogTitle id="alert-dialog-title">{"Refund Transaction"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">

                        {/* 
                        <Hidden smDown>
                            <Typography variant="h4" style={{ padding: "10px" }}>
                                Your new booking total is {genfunction.ccyFormat(AmountToPay())} and your total paid is {bookingreducer.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0}.
                            </Typography>
                        </Hidden>

                        <Hidden xsDown mdUp>
                            <Typography variant="h5" style={{ padding: "10px" }}>
                                Your new booking total is {genfunction.ccyFormat(AmountToPay())} and your total paid is {bookingreducer.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0}.
                            </Typography>
                        </Hidden>

                        <Hidden smUp>
                            <Typography variant="h6" style={{ padding: "10px" }}>
                                Your new booking total is {genfunction.ccyFormat(AmountToPay())} and your total paid is {bookingreducer.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0}.
                            </Typography>
                        </Hidden> */}


                        <Hidden smDown>
                            <Typography variant="h4" style={{ padding: "10px" }}>
                                {"Your previous payment:" + genfunction.ccyFormat(totalpaid())}
                            </Typography>
                            <Typography variant="h4" style={{ padding: "10px" }}>
                                {"Now we owe you: " + genfunction.ccyFormat(Math.abs(AmountToPay()))}
                            </Typography>
                        </Hidden>

                        <Hidden xsDown mdUp>
                            <Typography variant="h4" style={{ padding: "10px" }}>
                                {"Your previous payment:" + genfunction.ccyFormat(totalpaid())}
                            </Typography>
                            <Typography variant="h4" style={{ padding: "10px" }}>
                                {"Now we owe you: " + genfunction.ccyFormat(Math.abs(AmountToPay()))}
                            </Typography>
                        </Hidden>

                        <Hidden smUp>
                            <Typography variant="h4" style={{ padding: "10px" }}>
                                {"Your previous payment:" + genfunction.ccyFormat(totalpaid())}
                            </Typography>
                            <Typography variant="h4" style={{ padding: "10px" }}>
                                {"Now we owe you: " + genfunction.ccyFormat(Math.abs(AmountToPay()))}
                            </Typography>
                        </Hidden>

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Hidden smDown>
                        <Button onClick={handleClose} variant="outlined" size="medium" color="primary">
                            Cancel Changes
                        </Button>

                        <Button onClick={() => applyrefund('CreditCardRefund')} variant="contained" size="medium" color="primary"
                            className={bookingreducer.booking[0] && bookingreducer.booking[0].AllowRefunds && !bookingreducer.booking[0].AllowRefundToGiftcardOnly ? '' : classes.hideBtn}  >
                            {RefundCreditCardButton}
                        </Button>

                        <Button
                            onClick={() => applyrefund('GiftCardRefund')}
                            variant="contained" size="medium" color="primary"
                            className={bookingreducer.booking[0] && (bookingreducer.booking[0].AllowRefunds || bookingreducer.booking[0].AllowRefundToGiftcardOnly) ? '' : classes.hideBtn}  >
                            {RefundGiftCardButton}
                        </Button>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Button onClick={handleClose} variant="outlined" size="small" color="primary">
                            Cancel Changes
                        </Button>

                        <Button onClick={() => applyrefund('CreditCardRefund')} variant="contained" size="small" color="primary"
                            className={bookingreducer.booking[0] && bookingreducer.booking[0].AllowRefunds && !bookingreducer.booking[0].AllowRefundToGiftcardOnly ? '' : classes.hideBtn}  >

                            {RefundCreditCardButton}
                        </Button>

                        <Button
                            onClick={() => applyrefund('GiftCardRefund')}
                            variant="contained" size="small" color="primary"
                            className={bookingreducer.booking[0] && (bookingreducer.booking[0].AllowRefunds || bookingreducer.booking[0].AllowRefundToGiftcardOnly) ? '' : classes.hideBtn}  >
                            {RefundGiftCardButton}
                        </Button>
                    </Hidden>

                    <Hidden smUp>
                        <Button onClick={handleClose} variant="outlined" size="small" color="primary">
                            Cancel Changes
                        </Button>

                        <Button onClick={() => applyrefund('CreditCardRefund')} variant="contained" size="small" color="primary"
                            className={bookingreducer.booking[0] && bookingreducer.booking[0].AllowRefunds && !bookingreducer.booking[0].AllowRefundToGiftcardOnly ? '' : classes.hideBtn}  >
                            {RefundCreditCardButton}
                        </Button>

                        <Button
                            onClick={() => applyrefund('GiftCardRefund')}
                            variant="contained" size="small" color="primary"
                            className={bookingreducer.booking[0] && (bookingreducer.booking[0].AllowRefunds || bookingreducer.booking[0].AllowRefundToGiftcardOnly) ? '' : classes.hideBtn}  >
                            {RefundGiftCardButton}
                        </Button>
                    </Hidden>


                </DialogActions>
            </Dialog>


            <Grid container alignItems="center" style={{ minHeight: '10vh', marginTop: 30 }} justify="center" spacing={0} className={bookingreducer.booking[0] && bookingreducer.booking[0].BookingID ? classes.hideBtn : ''}>
                <Typography variant="h4" className={classes.AdjustContext}>
                    Please go to find my booking page to Update Booking.
                </Typography>
                <Grid item xs={12} md={12} align="center">

                    <Button variant="outlined" size="medium" color="primary" className={classes.AdjustContext} style={{ padding: "12px" }}
                        onClick={() => redirecttofindmybpooking()}>
                        Manage My Booking
                    </Button>
                </Grid>
            </Grid>
        </Container >
    );
};

export default ConfimBookingChanges;
